import { render, staticRenderFns } from "./DetailMobile.vue?vue&type=template&id=42221d8c&"
import script from "./DetailMobile.vue?vue&type=script&lang=js&"
export * from "./DetailMobile.vue?vue&type=script&lang=js&"
import style0 from "./DetailMobile.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports